// auth lib
import getAuthEndpoints from '../../auth/lib/getAuthEndpoints.lib.auth';

const getEndpoint = (app) =>
  [...getAuthEndpoints()].find((endpoint) => endpoint.app === app)?.url || '';

export default getEndpoint;
